document.addEventListener('DOMContentLoaded', function () {
	const mobileQuery = window.matchMedia('(max-width: 899px)');
	const track = document.querySelector('[data-featured-case-studies-scroll]');
	const prevBtn = document.querySelector('.featured-case-studies-scroll-left');
	const nextBtn = document.querySelector('.featured-case-studies-scroll-right');

	if (!track || !prevBtn || !nextBtn) return;

	let currentIndex = 0;

	function getCards() {
		return Array.from(track.querySelectorAll('.card'));
	}

	function setButtonState(button, enabled) {
		const activeColor = '#ffffff';
		const disabledColor = '#8a8a8a';
		button.classList.toggle('disabled', !enabled);
		button.style.opacity = enabled ? '1' : '0.55';
		button.style.cursor = enabled ? 'pointer' : 'default';
		button.querySelectorAll('path').forEach(path => {
			path.style.fill = enabled ? activeColor : disabledColor;
		});
	}

	function updateButtons() {
		const cards = getCards();
		const maxIndex = Math.max(cards.length - 1, 0);
		setButtonState(prevBtn, currentIndex > 0);
		setButtonState(nextBtn, currentIndex < maxIndex);
	}

	function scrollToIndex(index) {
		const cards = getCards();
		if (!cards.length) return;

		const maxIndex = cards.length - 1;
		currentIndex = Math.max(0, Math.min(index, maxIndex));

		if (!mobileQuery.matches) {
			updateButtons();
			return;
		}

		const target = cards[currentIndex];
		if (!target) return;

		track.scrollTo({
			left: target.offsetLeft - track.offsetLeft,
			behavior: 'smooth',
		});

		updateButtons();
	}

	function syncIndexFromScroll() {
		if (!mobileQuery.matches) return;
		const cards = getCards();
		if (!cards.length) return;

		const left = track.scrollLeft;
		let nearest = 0;
		let bestDistance = Number.POSITIVE_INFINITY;

		cards.forEach((card, index) => {
			const distance = Math.abs(card.offsetLeft - track.offsetLeft - left);
			if (distance < bestDistance) {
				bestDistance = distance;
				nearest = index;
			}
		});

		currentIndex = nearest;
		updateButtons();
	}

	prevBtn.addEventListener('click', function () {
		scrollToIndex(currentIndex - 1);
	});

	nextBtn.addEventListener('click', function () {
		scrollToIndex(currentIndex + 1);
	});

	let scrollTimer = null;
	track.addEventListener('scroll', function () {
		if (scrollTimer) clearTimeout(scrollTimer);
		scrollTimer = setTimeout(syncIndexFromScroll, 100);
	});

	window.addEventListener('resize', function () {
		scrollToIndex(currentIndex);
	});

	scrollToIndex(0);
});
